module.exports = __webpack_public_path__ + "img/copy.c557bd04.svg";